<template>
  <v-layout>
    <v-flex v-if="!overlay">
      <v-card
          class="mt-12 mb-12"
          shaped
      >
        <v-toolbar
            dark
        >
          <v-app-bar-nav-icon @click="back">
            <v-icon>mdi-close</v-icon>
          </v-app-bar-nav-icon>

          <v-toolbar-title>Fach: {{ subject.FachName }}</v-toolbar-title>

          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text class="pa-6 pt-8">
          <v-form>
            <v-row class="mb-n8">
              <v-col md="8">
                <v-text-field
                    v-model="subject.FachName"
                    type="text"
                    label="Fachname"
                    outlined
                    :error-messages="form.errors.get('FachName')"
                ></v-text-field>
              </v-col>
              <v-col v-if="isFFM" md="4">
                <v-text-field
                    v-model="subject.STP_Kurz"
                    type="text"
                    label="Untis Kürzel"
                    outlined
                    :error-messages="form.errors.get('STP_Kurz')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mb-n8">
              <v-col :md="8">
                <v-text-field
                    v-model="subject.fachkuerzel"
                    type="text"
                    label="Fachkürzel"
                    outlined
                    :error-messages="form.errors.get('fachkuerzel')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mb-n8">
              <v-col>
                <v-text-field
                    v-model="subject.description"
                    type="text"
                    label="Beschreibung"
                    outlined
                    :error-messages="form.errors.get('description')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mb-n8">
              <v-card-title>Weitere Einstellungen</v-card-title>
            </v-row>
            <v-row>
              <v-col md="3">
                <v-switch
                    v-model="subject.schrPruefung"
                    label="Schriftliche Prüfung"
                    outlined
                ></v-switch>
              </v-col>
              <v-col md="3">
                <v-switch
                    v-model="subject.assessable"
                    label="Benotbares Fach"
                    outlined
                ></v-switch>
              </v-col>
              <v-col md="3">
                <v-switch
                    v-model="subject.consider_absents"
                    label="Fehlzeiten inkludieren"
                    outlined
                ></v-switch>
              </v-col>
              <v-col md="3" v-if="isFFM">
                <v-switch
                    v-model="subject.is_elective"
                    label="Fach für Kurswahl"
                    outlined
                ></v-switch>
              </v-col>
                <v-col v-if="isFFM" md="3">
                    <v-switch
                        v-model="subject.for_social_grades"
                        label="Fach für Arbeits- und Sozialverhalten"
                        outlined
                    ></v-switch>
                </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-6 pb-8">
          <v-btn
              :loading="form.busy"
              :disabled="form.busy"
              color="primary"
              large
              @click.prevent="submit()"
          >
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <overlay v-model="overlay"></overlay>
  </v-layout>
</template>

<script lang="ts">
import {computed, defineComponent, reactive, toRefs} from '@vue/composition-api'
import {useStore} from '../../store'
import {useForm} from '../../core/form'
import {Subject} from '../../core/models/subject'
import {useHttp} from "../../core/http";
import swal from 'sweetalert';

export default defineComponent({
  name: 'PageSubjectEdit',

  props: {
    id: Number,
    returnUrl: {
      type: String,
      required: true
    },
  },

  /**
   * @param props
   */
  setup(props) {
    const store = useStore()

    const state = reactive({
      overlay: false,
      isFFM: false,
    })

    if (props.id) {
      state.overlay = true
      store.dispatch('subject/get', {id: props.id}).then(() => {
        state.overlay = false
      })
    }

    useHttp().get('params?param=appLocation').then((data: any) => {
      state.isFFM = data.data === 'FFM'
    })

    const subjectModel = computed(() => <Subject>store.getters['subject/get'])

    const form = reactive(useForm())

    const submit = () => {

      let subject = subjectModel.value.payload()
      let isValidated = true

      form.clear()

      if (!subject.FachName) {
        form.errors.set('FachName', 'Bitte einen Fachnamen angeben!')
        isValidated = false
      }

      if (!subject.fachkuerzel) {
        form.errors.set('fachkuerzel', 'Bitte ein Fachkürzel angeben!')
        isValidated = false
      }

      if (!subject.STP_Kurz && state.isFFM) {
        form.errors.set('STP_Kurz', 'Bitte ein Untis Kürzel angeben!')
        isValidated = false
      }

      if (isValidated) {
        form
            .usingSubmit(store.dispatch('subject/updateOrCreate', {
              id: props.id,
              payload: subject
            }))
            .then(() => {
              swal('Erfolgreich', 'Daten erfolgreich gespeichert.', 'success');
            })
      }
    }

    const back = () => {
      window.location.href = props.returnUrl
    }

    return {
      form,
      back,
      submit,
      subject: subjectModel.value,
      ...toRefs(state)
    }
  }
})
</script>
